<script lang="ts">
  import AwsLockIcon from "./awsLockIcon.svelte";

  export let label: string;
  export let locked = false;
</script>

<div>
  <span class="mb-1 flex items-center gap-1.5 text-xs font-medium text-secondary-500">
    {label}
    <AwsLockIcon {locked} />
  </span>
  <slot />
</div>
